<template>
    <BackboneContainer
      :id="id"
      :className="className"
      :dispatchReadyOnMount="dispatchReadyOnMount"
    />
</template>

<script>
// @ is an alias to /src
import BackboneContainer from '@/components/BackboneContainer.vue';

export default {
  name: 'BackboneView',
  components: {
    BackboneContainer,
  },
  props: {
    id: {
      type: String,
      default: 'backbone-placeholder',
    },
    className: {
      type: String,
      default: 'theme-default',
    },
    dispatchReadyOnMount: {
      type: Boolean,
      default: false,
    },
    onMounted: Function,
  },
  mounted() {
    if (typeof this.onMounted === 'function') {
      this.onMounted.call(this);
    }
  },
};
</script>
